__turbopack_context__.v({
  "author": "news-card-module__q4mLkG__author",
  "authorAvatar": "news-card-module__q4mLkG__authorAvatar",
  "authorInfo": "news-card-module__q4mLkG__authorInfo",
  "authorName": "news-card-module__q4mLkG__authorName",
  "authorRole": "news-card-module__q4mLkG__authorRole",
  "card": "news-card-module__q4mLkG__card",
  "category": "news-card-module__q4mLkG__category",
  "content": "news-card-module__q4mLkG__content",
  "date": "news-card-module__q4mLkG__date",
  "divider": "news-card-module__q4mLkG__divider",
  "excerpt": "news-card-module__q4mLkG__excerpt",
  "image": "news-card-module__q4mLkG__image",
  "imageContainer": "news-card-module__q4mLkG__imageContainer",
  "imagePoster": "news-card-module__q4mLkG__imagePoster",
  "link": "news-card-module__q4mLkG__link",
  "meta": "news-card-module__q4mLkG__meta",
  "metaRight": "news-card-module__q4mLkG__metaRight",
  "playBadge": "news-card-module__q4mLkG__playBadge",
  "readTime": "news-card-module__q4mLkG__readTime",
  "title": "news-card-module__q4mLkG__title",
  "video": "news-card-module__q4mLkG__video",
});
